// Nominatim city search + reverse geocoding for the place picker.
// Shared by the web PlacePicker and the mobile weather-location-settings
// surface so the two clients cannot drift on header, fallback, or zoom
// strategy.
async function fetchReverseGeocode(lat, lon, zoom) {
    try {
        const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&zoom=${zoom}&lat=${lat}&lon=${lon}`, { headers: { "Accept-Language": "en", "User-Agent": "HealthOS/1.0" } });
        if (!res.ok)
            return null;
        return (await res.json());
    }
    catch {
        return null;
    }
}
export async function reverseGeocode(lat, lon) {
    // Try zoom=12 (town level) then zoom=10 (city level). Some administrative
    // structures (e.g. Irish electoral districts) expose no city field at
    // either level; fall back to display_name from zoom=10 + country.
    for (const zoom of [12, 10]) {
        const result = await fetchReverseGeocode(lat, lon, zoom);
        if (!result)
            continue;
        const addr = result.address;
        const place = addr?.city ?? addr?.town ?? addr?.village ?? addr?.municipality;
        const country = addr?.country;
        if (place && country)
            return `${place}, ${country}`;
        if (place)
            return place;
        if (zoom === 10 && result.display_name && country) {
            const first = result.display_name.split(",")[0]?.trim();
            if (first)
                return `${first}, ${country}`;
        }
    }
    return `${lat.toFixed(3)}, ${lon.toFixed(3)}`;
}
export async function searchLocations(query) {
    try {
        const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5&featuretype=city`, { headers: { "Accept-Language": "en", "User-Agent": "HealthOS/1.0" } });
        if (!res.ok)
            return [];
        const json = (await res.json());
        return json.map((r) => ({
            label: r.display_name,
            lat: Number.parseFloat(r.lat),
            lon: Number.parseFloat(r.lon),
        }));
    }
    catch {
        return [];
    }
}
//# sourceMappingURL=geocode.js.map